export const data = {
  data: {
    clientContract: {
      table: {
        ref: 'Ref. Cliente',
        description: 'Descripcion',
        price: 'Precio',
        agreed: 'Kilogramos Pactados (KG)',
        available: 'Kilogramos Pendientes (KG)',
        lastOrder: 'Fecha Del Ultimo Pedido',
        validity: 'Fecha Validez Del Contrato'
      },
    },
  }
};
